export const VERIFY_SESSION = '[Auth] Verify session';
export const INVALIDATE_SESSION = '[Auth] Invalidate session';
export const LOGIN = '[Auth] Login';
export const LOGIN_SUCCESS = '[Auth] Login success';
export const LOGOUT = '[Auth] Logout';
export const TOKEN_REFRESH = '[Auth] Token Refresh';
export const USER_CHANGED_PASSWORD = '[Auth] User Changed Password';
export const LOGIN_FAILED = '[Auth] Login failed';